export enum FileType {
  PDF = 'pdf',
  DOCX = 'docx',
  DOC = 'doc',
  PPTX = 'pptx',
  PPT = 'ppt',
  XLSX = 'xlsx',
  XLS = 'xls',
  TXT = 'txt',
  MD = 'md',
  HTML = 'html',
  CSV = 'csv',
}

// 知識ベース（マテリアル管理）でサポートする形式のみ
export enum KnowledgeBaseFileType {
  PDF = 'pdf',
  TXT = 'txt',
  MD = 'md',
  CSV = 'csv',
}

// 知識ベースでサポートする形式の配列
export const SUPPORTED_KNOWLEDGE_BASE_TYPES = [
  KnowledgeBaseFileType.PDF,
  KnowledgeBaseFileType.TXT,
  KnowledgeBaseFileType.MD,
  KnowledgeBaseFileType.CSV,
] as const;

export enum ExtractionStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export enum MaterialSortBy {
  NAME = 'name',
  SIZE = 'size',
  CREATED_AT = 'createdAt',
  UPDATED_AT = 'updatedAt',
  EXTRACTION_STATUS = 'extractionStatus',
}

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}